module.exports = __webpack_public_path__ + "static/media/skills.acaf1569.jpg";